var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextInput } from 'src/ui/components/Input/TextInput/TextInput';
import styles from './usersListFilters.module.scss';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var UsersListFilters = function (props) {
    var filters = props.filters, i18n = props.i18n, updateFilters = props.updateFilters;
    var searchInputLabel = getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, 'userFilter.fullSearchLabel');
    var handleSearchChange = function (value) {
        updateFilters({ search: value, offset: 0 }); // set offset to 0 to reset pagination when search changes
    };
    return (_jsx("div", __assign({ className: styles.filtersWrapper }, { children: _jsx("div", __assign({ className: styles.filtersInputsWrapper }, { children: _jsx(TextInput, { label: searchInputLabel, value: (filters === null || filters === void 0 ? void 0 : filters.search) || '', onChange: handleSearchChange, className: styles.input, rightIcon: E_ICONS.SEARCH, timeDebounce: 1000 }) })) })));
};
